// A case_jobs (szolgáltatói folyamat) aktív státuszainak 3 fázisra
// egyszerűsítése a kanban-kártya / lista-sor jelvényhez. A sorrend
// egyezik a backend caseController.js JOB_STATUS_ORDER-jével — ha ott
// bővül a workflow, itt is bővíteni kell.
const QUOTE_PHASE = new Set([
  'contact_pending', 'quote_requested', 'quote_received',
  'awaiting_customer_approval', 'quote_rejected',
]);
const EXECUTION_PHASE = new Set([
  'quote_accepted', 'scheduled', 'in_progress', 'on_hold', 'work_rejected',
]);
const BILLING_PHASE = new Set(['work_done', 'accepted', 'invoiced']);

// 'quote' (árajánlat/egyeztetés) | 'execution' (ütemezve/folyamatban) | 'billing' (kész, számlázásra vár)
export function jobPhase(status) {
  if (QUOTE_PHASE.has(status)) return 'quote';
  if (EXECUTION_PHASE.has(status)) return 'execution';
  if (BILLING_PHASE.has(status)) return 'billing';
  return 'execution';
}
